export default __webpack_public_path__ + "static/media/reunion21_w640.88764ab3.jpg";